export default __webpack_public_path__ + "static/media/envi-plansh.8dfcafad.svg";